import React from 'react';

import "./style.css"
import MyCalculator from './test';
import { useTranslation } from 'react-i18next';


const Calculator: React.FC = () => {
    const {t} = useTranslation()

    return (
        <div className='w-full pb-10'>

            <MyCalculator/>

            <div className='mt-8'>
                <h2 className='text-[22px] font-bold text-[#17608B]'>
                    {t('The Uzbekistan Dispute Resolution Centre (UDRC)')}
                </h2>
                <div className='text-[20px] font-medium mt-5 w-[50%]'>
                    <p>
                        {t('Address: 100047, Republic of Uzbekistan, Tashkent city, Sayilgokh Street, Building 35')}
                    </p>
                </div>
                <div className='grid grid-cols-12 gap-4 mt-6'>
                    <div className='lg:col-span-6 sm:col-span-6 col-span-12'>
                        <h3 className='font-semibold text-base'>{t("Phone")}: (71) 233-66-36, (90) 167-27-73</h3>
                        <ol className='p-0 m-0 flex flex-col text-[15px]'>
                            <li>{t('Legal Form Code: 270 – Institution')}</li>
                            <li>{t('OKED Code: 74900')}</li>
                            <li>{t('NGO Registration Code: 79974 (NGO)')}</li>
                            <li>{t('State Registration Code: 949')}</li>
                            <li>{t('SOATO Code: 1726266')}</li>
                            <li>{t('OKPO Code: 60031826')}</li>
                            <li>{t('STIR: 207326904')}</li>
                        </ol>
                    </div>
                    <div className='lg:col-span-6 sm:col-span-6 col-span-12'>
                        <h3 className='font-semibold text-base'>{t('Bank: JSC <<Aloqabank>>, Operations RCIS')}</h3>
                        <ol className='p-0 m-0 flex flex-col text-[15px]'>
                            <li>{t('MFO (Bank Code): 00401')}</li>
                            <li>{t('Bank Account Numbers:')}</li>
                            <li className='font-semibold text-blue-400'>(UZS) 20212000805295895001</li>
                            <li className='font-semibold text-blue-400'>(USD) 20212840405295895001</li>
                            <li className='font-semibold text-blue-400'>(EUR) 20212978305295895001</li>
                        </ol>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default Calculator;